import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  dividerHorizontal: {
    padding: "8px 0px",
    height: "1px",
  },
}));

export default styles;
